export default {
  'grapesjs-mjml': {
    category: '',
    panels: {
      buttons: {
        undo: 'Undo',
        redo: 'Redo',
        desktop: 'Desktop',
        tablet: 'Tablet',
        mobile: 'Mobile',
        import: 'Import MJML',
      },
      import: {
        title: 'Import MJML',
        button: 'Import',
        label: '',
      },
      export: {
        title: 'Export MJML',
      },
    },
    components: {
      names: {
        body: 'Body',
        button: 'Button',
        column: 'Column',
        oneColumn: '1 Column',
        twoColumn: '2 Columns',
        threeColumn: '3 Columns',
        divider: 'Divider',
        group: 'Group',
        hero: 'Hero',
        image: 'Image',
        navBar: 'Navbar',
        navLink: 'Navbar Link',
        section: 'Section',
        socialGroup: 'Group Social',
        socialElement: 'Social Element',
        spacer: 'Spacer',
        text: 'Text',
        wrapper: 'Wrapper',
        raw: 'Raw',
      },
    }
  },
};
